import React, { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";

function TaxBillPrint({
  name,
  mobile,
  address,
  amount,
  amount_in_words,
  receiver,
  receiptno,
  date,
  festival_type,
  AfterPrintClose,
}) {
  console.log("date", date);
  const logo = require("../assets/images/logo.jpg");
  const printTriggerBtn = useRef();
  const printComponentRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      printTriggerBtn.current.click();
    }, 0);
  }, []);
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <button className="d-none" ref={printTriggerBtn}>
            Print
          </button>
        )}
        content={() => printComponentRef.current}
        onAfterPrint={() => {
          AfterPrintClose();
        }}
      />
      <div
        ref={printComponentRef}
        className="container-fluid border shadow my-3 border-dark print-receipt-wrapper"
        style={{ padding: '40px' }}
      >
        {/* Header Section */}
        <p className="text-center text-danger fw-bold mb-0" style={{ fontSize: '24px' }}>உ</p>
        <div className="d-flex align-items-center justify-content-center mb-2">
          <img
            src={logo}
            style={{ height: '110px', width: '110px' }}
            className="rounded-circle me-4"
            alt="logo"
          />
          <div className="text-center">
            <p className="text-danger fw-bold mb-1" style={{ fontSize: '18px' }}>
              ஸ்ரீ மஹா கணபதி அனுக்ரஹம் | ஸ்ரீ சிவகாமியம்மன் சமேத ஸ்ரீ ஆலடீஸ்வரன் துணை
            </p>
            <h3 className="fw-bold text-success mb-1" style={{ fontSize: '28px' }}>
              ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
            </h3>
            <p className="text-dark mb-0" style={{ fontSize: '20px' }}>
              <span className="fw-bold">ஈஞ்சார்</span>, சிவகாசி மேற்கு, விருதுநகர் மாவட்டம் - 626124
            </p>
          </div>
        </div>

        {/* Receipt Title */}
        <div className="text-center mb-3">
          <span
            className="fw-bold text-uppercase px-5 py-2 d-inline-block"
            style={{
              fontSize: '22px',
              border: '2px solid #d4a017',
              letterSpacing: '1px',
            }}
          >
            {festival_type === 'Kumbaabishegam' ? `கும்பாபிஷேகம் ${new Date().getFullYear()} வரி ரசீது` : `வரி ரசீது ${new Date().getFullYear()}`}
          </span>
        </div>

        <hr className="my-2" style={{ borderTop: '2px solid #333' }} />

        {/* Receipt No & Date */}
        <div className="d-flex justify-content-between mb-3 mt-2">
          <p className="fw-bold mb-0" style={{ fontSize: '22px' }}>
            ரசீது எண்: <span className="text-dark">{receiptno}</span>
          </p>
          <p className="fw-bold mb-0" style={{ fontSize: '22px' }}>
            தேதி: <span className="text-dark">{date}</span>
          </p>
        </div>

        {/* Details Table */}
        <table className="w-100 mb-3" style={{ fontSize: '22px', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td className="fw-bold py-3 pe-2" style={{ width: '120px', borderBottom: '1px solid #ddd', verticalAlign: 'top' }}>
                பெயர் :
              </td>
              <td className="py-3" style={{ borderBottom: '1px solid #ddd' }}>
                <span className="fw-bold">{name}</span>
              </td>
              <td className="fw-bold py-3 pe-2 ps-4" style={{ width: '100px', borderBottom: '1px solid #ddd', verticalAlign: 'top' }}>
                செல் :
              </td>
              <td className="py-3" style={{ borderBottom: '1px solid #ddd' }}>
                <span className="fw-bold">{mobile}</span>
              </td>
            </tr>
            <tr>
              <td className="fw-bold py-3 pe-2" style={{ borderBottom: '1px solid #ddd', verticalAlign: 'top' }}>
                முகவரி :
              </td>
              <td className="py-3" colSpan="3" style={{ borderBottom: '1px solid #ddd' }}>
                <span className="fw-bold">{address}</span>
              </td>
            </tr>
            <tr>
              <td className="fw-bold py-3 pe-2" style={{ borderBottom: '1px solid #ddd', verticalAlign: 'top' }}>
                ரூபாய் :
              </td>
              <td className="py-3" colSpan="3" style={{ borderBottom: '1px solid #ddd' }}>
                <span className="fw-bold">{amount_in_words}</span>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Amount, Phone, Collector Footer */}
        <div className="d-flex justify-content-between align-items-center mt-4 pt-3" style={{ borderTop: '2px solid #333' }}>
          <div className="d-flex align-items-center">
            <span
              className="fw-bold text-white px-3 py-1 me-2"
              style={{ backgroundColor: '#555', fontSize: '20px' }}
            >
              Rs
            </span>
            <span className="fw-bold" style={{ fontSize: '26px' }}>₹ {amount}</span>
          </div>
          <div className="text-center">
            <span style={{ fontSize: '20px' }}>செல்: </span>
            <span className="fw-bold" style={{ fontSize: '20px' }}>9994604513</span>
          </div>
          <div className="d-flex align-items-center">
            <span
              className="fw-bold text-white px-3 py-1 me-2"
              style={{ backgroundColor: '#555', fontSize: '18px' }}
            >
              வசூலிப்பவர்
            </span>
            <span className="fw-bold" style={{ fontSize: '22px' }}>{receiver}</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TaxBillPrint;
